import { useEffect, useState } from 'react';
import { getStagePresence, isStagePresent, pingStage, subscribeStagePresence } from './lessonStage';

// Re-read presence this often, so "On" decays to "Off" when a stage window
// stops saying it is there (closed, crashed, or its Mac went to sleep).
const TICK_MS = 1000;

/**
 * Is a stage window open in this browser, and what is it showing? Pings on
 * mount so an already-open stage answers at once rather than at its next
 * heartbeat. Returns { present, mode, has }: `has` is what the stage could
 * show ({ lyrics, video }), so the menu can say why a choice is unavailable.
 */
const useStagePresence = () => {
	const [, setTick] = useState(0);
	const [presence, setPresence] = useState(getStagePresence);

	useEffect(() => {
		const off = subscribeStagePresence((p) => setPresence({ ...p }));
		pingStage();
		const t = setInterval(() => setTick((n) => n + 1), TICK_MS);
		return () => {
			off();
			clearInterval(t);
		};
	}, []);

	return { present: isStagePresent(), mode: presence.mode || 'idle', has: presence.has || { lyrics: false, video: false } };
};

export default useStagePresence;
